import { Session } from "src/app/backend/models/session";
import { getDatabase } from "src/app/repositories/app-db";

export class SessionRepository {
  readonly #db = getDatabase();

  async create(session: Session): Promise<void> {
    await this.#db.sessions.add(session);
  }

  async list(): Promise<Session[]> {
    return await this.#db.sessions.toArray();
  }

  async delete(id: number): Promise<void> {
    await this.#db.sessions.delete(id);
  }

  async deleteByMemberId(memberId: string): Promise<void> {
    await this.#db.sessions.where("memberId").equals(memberId).delete();
  }

  async deleteByMemberAccountDomain({
    memberId,
    accountNickName,
    domainName
  }: {
    memberId: string;
    accountNickName: string;
    domainName: string;
  }): Promise<void> {
    await this.#db.sessions
      .where({
        memberId,
        accountNickName,
        domainName
      })
      .delete();
  }
}
